import { SelectorCardOperativeStates } from '../../../../../../components/selectorCardOperative/types/selectorCardOperativeStates';
import { SelectorCardOperativeVariants } from '../../../../../../components/selectorCardOperative/types/selectorCardOperativeVariants';
import { commonStyles } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT) => ({
    [SelectorCardOperativeVariants.REGULAR]: {
        [SelectorCardOperativeStates.UNSELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_comp_containers_bg,
                    border_width: FOUNDATIONS.border_25,
                    border_color: FOUNDATIONS.color_neutral_border_150,
                },
                radio: {
                    background_color: FOUNDATIONS.color_comp_forms_radiobutton_unselected_bg,
                    border_width: FOUNDATIONS.border_50,
                    border_color: FOUNDATIONS.color_neutral_border_150,
                    before: {
                        background_color: FOUNDATIONS.color_comp_forms_radiobutton_unselected_bg,
                    },
                },
            }),
        },
        [SelectorCardOperativeStates.SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_comp_containers_bg,
                    border_width: FOUNDATIONS.border_75,
                    border_color: FOUNDATIONS.color_accent_selected_border_50,
                },
                radio: {
                    background_color: FOUNDATIONS.color_comp_forms_radiobutton_selected_bg,
                    border_width: FOUNDATIONS.border_100,
                    border_color: FOUNDATIONS.color_accent_selected_border_50,
                    before: {
                        background_color: FOUNDATIONS.color_accent_selected_icon_50,
                    },
                },
            }),
        },
        [SelectorCardOperativeStates.DISABLED_UNSELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_200,
                    border_width: FOUNDATIONS.border_25,
                    border_color: FOUNDATIONS.color_neutral_border_150,
                },
                radio: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border_width: FOUNDATIONS.border_50,
                    border_color: FOUNDATIONS.color_accent_disabled_border_100,
                    before: {
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    },
                },
            }),
        },
        [SelectorCardOperativeStates.DISABLED_SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_200,
                    border_width: FOUNDATIONS.border_75,
                    border_color: FOUNDATIONS.color_accent_selected_border_50,
                },
                radio: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border_width: FOUNDATIONS.border_100,
                    border_color: FOUNDATIONS.color_accent_disabled_border_100,
                    before: {
                        background_color: FOUNDATIONS.color_accent_disabled_icon_50,
                    },
                },
            }),
        },
    },
});
//# sourceMappingURL=regular.js.map